import styled from '@emotion/styled';
import React from 'react';
import {
	ArrowBackIcon,
	ContentWrap,
	Css,
	ITheme,
	Responsive,
} from '../../../../../ui';
import LinkButton from '../../../../../components/common/button/LinkButton';
import { Color } from '../../../../../styles/Color';
import { PageRoutes } from '../../../../app/pages/domain/constants/PageRoutes';

export default function SolicitationHeaderBackLink() {
	return (
		<BackLinkRow>
			<BackLinkWrap>
				<StyledLinkButton
					href={PageRoutes.CorporateSolicitations}
					buttonType="text"
					icon={<ArrowBackIcon role="presentation" />}
					iconPosition="left"
					aria-label="Navigate back to Solicitations"
				>
					Solicitations
				</StyledLinkButton>
			</BackLinkWrap>
		</BackLinkRow>
	);
}

const BackLinkRow = styled.div`
	background-color: ${Color.Neutral2};
	width: 100%;

	padding-top: ${Css.pxToRem(66)};
	padding-bottom: ${Css.pxToRem(24)};

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		padding-left: ${Css.pxToRem(24)};
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		padding-top: ${Css.pxToRem(60)};
		padding-bottom: ${Css.pxToRem(20)};
		padding-left: ${Css.pxToRem(8)};
	}
`;

const BackLinkWrap = styled(ContentWrap)`
	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		margin-left: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-left: 0;
	}
`;

const StyledLinkButton = styled(LinkButton)<{}, ITheme>`
	color: ${Color.OnBackground};

	&:hover {
		cursor: pointer;
		color: ${Color.OnBackground};

		svg {
			transform: translateX(-${(props) => props.theme.button?.iconSeparator});
		}
	}
`;
